import * as React from "react";
import { translateChoice } from "@js/common/helpers";
export var MoodboardRow = function (_a) {
    var moodboard = _a.moodboard, onClick = _a.onClick;
    var images = moodboard.items.slice(0, 4).map(function (item, index) {
        return {
            index: index,
            path: item.files[0].path_thumbnail,
            is_look: true,
        };
    });
    while (images.length < 4) {
        images.push({
            index: images.length,
            path: '/images/blank.png',
            is_look: false,
        });
    }
    var count = moodboard.total_items === null ? 0 : moodboard.total_items;
    return (React.createElement("div", { className: "moodboard-item flex cursor-pointer", onClick: onClick },
        React.createElement("div", { className: "looks" }, images.map(function (image) { return (React.createElement("img", { key: image.index, className: 'look' + (image.is_look ? '' : ' blank-look'), src: image.path })); })),
        React.createElement("div", { className: "description" },
            React.createElement("div", { className: "description-content" },
                React.createElement("div", { className: "item-title", title: moodboard.name }, moodboard.name),
                React.createElement("div", { className: "item-count" }, translateChoice('moodboard_quicksave.modal.item_count', count, {
                    count: count,
                }))))));
};
